import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { quotes } from "../../../../../../redux/quotes/action";
import { selectQuotesListItems } from "../../../../../../redux/quotes/selector";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";

const ManagementQuotes = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageSize, setPageSize] = useState(10);
  const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectQuotesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Message.category_name', headerName: 'Category Name',searchField: 'Message.category_name', sortable: true, filter: true, filterType: 'text'},
    { field: 'Message.quote.price.value', headerName: 'Quote price',isCurrencyValueFormat: true},
    { field: 'Message.CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat:true,  },
    { field: 'Message.ModifiedOnUtc', headerName: 'ModifiedOn',isDateValueFormat:true,  },
        ]);
      }

     

      const fetchQuotes=()=>{
        dispatch(quotes.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes/list`,entity:'quotes',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      
      useEffect(() => {
        createColumnDefs()
        fetchQuotes()
	}, [pageData,pageSize])

  const handleAdd = () => {
    navigate(`${0}`)
  }

	
  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  const handleReloadData = () => {
    fetchQuotes()
  }
  const additionButtons: any = [
    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Message.category_name",
        FieldText: "Message.category_name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(quotes.list({
      url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes/list`,
      entity:'quotes',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
 <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
 enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons}  headingName="Quotes" />
  }
  </>
     
	);
};

export default ManagementQuotes;


